<mat-form-field appearance="outline" class="w-100">
  @if (label) {
    <mat-label>{{ label | translate }}</mat-label>
  }

  <mat-select
    #selectRef
    [formControl]="control"
    [placeholder]="placeholder | translate"
    (selectionChange)="onSelectionChange($event.value)"
  >
    @for (item of items; track item) {
      <mat-option [value]="item.value">
        {{ isTranslate ? (item.name | translate) : item.name }}
      </mat-option>
    }
  </mat-select>

  @if (control.touched && control.invalid) {
    <mat-error>
      @if (control.errors?.['required']) {
        {{ 'input_errors.required' | translate }}
      }
    </mat-error>
  }
</mat-form-field>
